/**
 * Returns a cookie `domain` value for sharing cookies across subdomains of the current host.
 * @returns {string | undefined}
 */
const getCrossSubdomainCookieDomain = () => {
	const {hostname} = window.location;

	if (hostname === 'localhost') {
		return undefined;
	}
	
	const parts = hostname.split('.');

	// Handle subdomains
	if (parts.length >= 3) {
		return `.${parts.slice(1).join('.')}`;
	}

	// No subdomain (no www either)
	return `.${hostname}`;
};

export {
	getCrossSubdomainCookieDomain
};